import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Business errors (not found, forbidden, validation) are final.
        if (error instanceof ApiError && !error.retryable) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
